import { render, staticRenderFns } from "./TaskImage.vue?vue&type=template&id=410f9b35"
import script from "./TaskImage.vue?vue&type=script&lang=js"
export * from "./TaskImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports